import { Box, Container, Divider, Stack, Typography } from '@mui/material';
import VerificationType, { VerifyIncomeType } from '../../../components/verification/VerificationType';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { ProofButton } from '../../../ui/button/ProofButton';
import { useSelector } from 'react-redux';
import { getEnableDocUpload } from '../../../store/ui/selector';

export default function IncomeVerificationTypes() {
  const { t } = useTranslation();
  const enableDocUpload = useSelector(getEnableDocUpload);
  const navigate = useNavigate();
  const { propertyCode } = useParams();
  const { search } = useLocation();
  const goToUpload = () => navigate(`/${propertyCode}/verification/upload${search}`);
  const slideSettings = {
    dots: true,
    infinite: false,
    centerMode: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <Container maxWidth="md" sx={{ px: { xs: 0, md: 3 } }}>
      <Container maxWidth="xs" sx={{ mb: 5, px: { xs: 3, md: 0 } }}>
        <Typography variant="h2" mb={2.5} textAlign="center" sx={{ fontWeight: 500, textAlign: { xs: 'left', md: 'center' } }}>
          {t('verification.type.title')}
        </Typography>
        <Typography variant="body1" sx={{ textAlign: { xs: 'left', md: 'center' } }}>
          {t('verification.type.desc')}
        </Typography>
      </Container>
      <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', sm: 'row' } }}>
        {verifyTypes.map(verifyType => (
          <VerificationType key={verifyType.type} type={verifyType.type} />
        ))}
      </Box>
      {enableDocUpload && (
        <Container maxWidth="sm" sx={{ px: [4, 4, 1] }}>
          <Stack flexDirection="row" alignItems="center">
            <Divider orientation="horizontal" sx={{ flex: 1, borderColor: '#979797' }} />
            <Typography sx={{ color: '#979797', width: '40px', textAlign: 'center', my: 1.5, fontWeight: 600 }}>OR</Typography>
            <Divider orientation="horizontal" sx={{ flex: 1, borderColor: '#979797' }} />
          </Stack>
          <Box>
            <ProofButton color="primary" variant="text" fullWidth sx={{ mb: 2, py: 1, fontSize: '13px' }} onClick={goToUpload}>
              {t('verification.type.document.button')}
            </ProofButton>
          </Box>
        </Container>
      )}
    </Container>
  );
}

const verifyTypes: { type: VerifyIncomeType }[] = [
  {
    type: VerifyIncomeType.Bank_Account,
  },
  {
    type: VerifyIncomeType.Payroll_Provider,
  },
  // {
  //   type: VerifyIncomeType.Paystubs,
  // },
];
